<template>
  <section id="detail_article" class="artikel_view_area pt-100 pb-100">
    <div class="container mt-5">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ=" crossorigin="anonymous" />
      <!-- START CONTENT -->
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12">
              <h4
                class="title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.2s"
              >
                {{ detailArtikel.judul }}
              </h4>
            </div>

            <div class="col-lg-12 mt-3">
              <div class="label_artikel_title col-sm-12">
                <p style="font-size: 0.6rem">
                  &nbsp;
                  <span
                    ><i class="lni lni-eye"></i>
                    {{ detailArtikel.visitor_count }}</span
                  >
                  &nbsp; &nbsp;
                  <span
                    ><i class="lni lni-calendar"></i>
                    {{ detailArtikel.waktu_buat }}</span
                  >
                  &nbsp;
                </p>
              </div>
            </div>

            <div class="col-lg-12 mt-3">
              <div v-html="detailArtikel.isi"></div>
            </div>

            <div class="col-lg-2 mt-5 share-network-list">
              <ShareNetwork
                  network="whatsapp"
                  :url= "`${appUrl}${detailArtikel.id}`"
                  :title= detailArtikel.judul
                  hashtags="vuejs,vite,javascript">
                <i class="fab fah fa-lg fa-whatsapp" ></i>
                <span>Share on Whatsapp</span>
              </ShareNetwork>
            </div>
          </div>
        </div>

        <div class="col-lg-4"></div>
      </div>
      <!-- END CONTENT -->

      <div class="row justify-content-left mt-5">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <p style="color: black">Artikel & Berita Lainnya</p>
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-lg-12">
          <div class="row">
            <div
              class="col-lg-4 zoom single_blog blog_2 d-sm-flex mt-20 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
              v-for="(artikel, index) in artikels"
              :key="index"
              @click="retrieveDetailArtikels(artikel.id)"
            >
              <div class="blog_content media-body mt-10 mb-10">
                <div class="row">
                  <div class="col-lg-4">
                    <!-- START IMAGES -->
                    <div v-if="artikel.image_source != ''">
                      <div
                        class="blog_image mb-20"
                        style="max-height: 10%"
                        v-html="artikel.image_source"
                      ></div>
                    </div>
                    <div v-else>
                      <img
                        style="max-height: 120%"
                        :src="process.env.VUE_APP_API_BASE_FILE+'/get-file?key=tjsl/logo_kai_27062022152956.jpg'"
                        alt="foto"
                      />
                    </div>
                    <!-- END IMAGES -->
                  </div>
                  <div class="col-lg-8">
                    <h1 class="label_blog_title">
                      <a class="two-line-overflow">
                        {{ artikel.judul }}
                      </a>
                    </h1>
                    <div class="label_artikel_title col-sm-12">
                      <p>
                        &nbsp;
                        <span
                          ><i class="lni lni-eye"></i>
                          {{ artikel.visitor_count }}</span
                        >
                        &nbsp; &nbsp;
                        <span
                          ><i class="lni lni-calendar"></i>
                          {{ artikel.waktu_buat }}</span
                        >
                        &nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />

          <div class="centerBlock">
            <paginate
              v-model="page"
              :page-count="pageCount"
              :click-handler="clickCallback"
              :prev-text="'Sebelumnya'"
              :next-text="'Selanjutnya'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :active-class="'myActiveBtn'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ArtikelDataService from "../services/ArtikelDataService";
import Paginate from "vuejs-paginate-next";
import axios from "axios";
export default {
  name: "artikelDetail",
  data() {
    return {
      id: "",
      pageCount: 0, //initial page pagination
      dataPerPage: 3, //for limiting per page
      detailArtikel: [],
      artikels: [],
      page: 1,
      appUrl:process.env.VUE_APP_URL+"#/detail_article/"
    };
  },
  components: {
    paginate: Paginate,
  },
  methods: {
    copyURL() {
      let url = document.location.href
      navigator.clipboard.writeText(url).then(function() {
          console.log('Copied!');
      }, function() {
          console.log('Copy error')
      });
    },

    retrieveDetailArtikels(id) {
      ArtikelDataService.findById(id)
        .then((response) => {
          this.detailArtikel = response.data.data;
          this.getUserAgent();
          // console.log(this.artikels.intro);
          // this.currentArtikel = this.artikels[0];
          // this.currentIndex = 0;
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getCountAllArtikels() {
      ArtikelDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveArtikels(offset, limit) {
      ArtikelDataService.getAll(offset, limit)
        .then((response) => {
          this.artikels = response.data.data;
          console.log(this.artikels);
          // this.currentArtikel = this.artikels[0];
          // this.currentIndex = 0;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clickCallback(pageNum) {
      console.log(pageNum - 1);
      this.retrieveArtikels(pageNum - 1, this.dataPerPage);
    },

    getUserAgent() {
      axios.get("https://geolocation-db.com/json/").then((response) => {
        ArtikelDataService.sendUserAgent(
          this.detailArtikel.id,
          "artikel",
          response.data.country_name,
          response.data.country_code,
          response.data.city,
          response.data.state,
          response.data.latitude,
          response.data.longitude,
          response.data.IPv4
        )
          .then((response) => {
            console.log(response.data);
            // this.currentArtikel = this.artikels[0];
            // this.currentIndex = 0;
          })
          .catch((e) => {
            console.log(e);
          });
        // this.products = response.data.products;
        // console.log(response.data.country_name);
      });
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.retrieveDetailArtikels(this.$route.params.id);
    this.getCountAllArtikels();
    this.retrieveArtikels(0, this.dataPerPage);
    //this.getUserAgent();
  },
};
</script>

<style>
.label_artikel_title p {
  color: #777777;
  font-size: 8px;
}

.centerBlock {
  display: table;
  margin: auto;
}

.text-overflow-handle {
  white-space: nowrap;
  max-width: 100%;
  height: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.two-line-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}
.share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    /* margin: auto; */
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF;
    background-color: #25d366;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>
